import React from 'react'

const times = Array.from(Array(5).keys())

function AreaListSkeleton() {
  return (
    <div className="w-full">
      <div className="custom-scrollbar flex h-full flex-col gap-[15px] overflow-y-auto">
        {times.map((item) => (
          <div
            key={item}
            className="shimmer-container relative rounded-lg bg-slate-700/30"
          >
            <div className="flex h-full w-full flex-col gap-3 px-8 py-6">
              <div className="flex w-full items-center justify-between">
                <p className="m-0"></p>
                <div className="flex h-[25px] w-[25px] items-center justify-center rounded-md" />
              </div>
              <div className="flex w-full items-center justify-between">
                <p className="m-0"></p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default AreaListSkeleton
